/**
 * Spacing Scale
 * 
 * Provides consistent spacing values for atomic components.
 * The tenant system doesn't have a spacing scale.
 */
export const spacing = {
  /** 2px - Extra small spacing */
  xs: '2px',
  /** 4px - Small spacing (e.g., badge icon gap) */
  sm: '4px',
  /** 8px - Medium spacing (e.g., stat gap) */
  md: '8px',
  /** 12px - Large spacing (e.g., component padding) */
  lg: '12px',
  /** 20px - Extra large spacing (e.g., section gaps) */
  xl: '20px',
  /** 24px - 2X large spacing */
  xxl: '24px',
} as const;

export type Spacing = typeof spacing;
